import React, { useState, useEffect } from 'react';

const SubjectForm = ({ subject, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    Nombre: '',
    Nivel: ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (subject) {
      setFormData({
        ...subject,
        Nivel: subject.Nivel ?? ''
      });
    }
  }, [subject]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextValue = name === 'Nivel'
      ? (value === '' ? '' : Number(value))
      : value;

    setFormData(prev => ({ ...prev, [name]: nextValue }));
    
    if (name === 'Nivel' && value !== '' && (Number(value) < 1 || Number(value) > 4)) {
      setErrors(prev => ({ ...prev, Nivel: 'El nivel debe estar entre 1 y 4' }));
    } else {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newErrors = {};
    
    if (!formData.Nombre.trim()) newErrors.Nombre = 'Nombre es requerido';
    if (formData.Nivel !== '' && (formData.Nivel < 1 || formData.Nivel > 4)) {
      newErrors.Nivel = 'El nivel debe estar entre 1 y 4';
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    onSubmit({
      ...formData,
      Nombre: formData.Nombre.trim(),
      Nivel: formData.Nivel === '' ? null : formData.Nivel
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-4">
        {/* Nombre */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Nombre *
          </label>
          <input
            type="text"
            name="Nombre"
            value={formData.Nombre}
            onChange={handleChange}
            className={`mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
              errors.Nombre ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500'
            }`}
            placeholder="Ej: Lenguaje Musical, Armonía..."
          />
          {errors.Nombre && (
            <p className="mt-1 text-sm text-red-600">{errors.Nombre}</p>
          )}
        </div>

        {/* Nivel */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Nivel
          </label>
          <select
            name="Nivel"
            value={formData.Nivel}
            onChange={handleChange}
            className={`mt-1 block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
              errors.Nivel ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500'
            }`}
          >
            <option value="">Sin nivel</option>
            {[1, 2, 3, 4].map(level => (
              <option key={level} value={level}>
                Nivel {level}
              </option>
            ))}
          </select>
          {errors.Nivel && (
            <p className="mt-1 text-sm text-red-600">{errors.Nivel}</p>
          )}
        </div>
      </div>

      {/* Botones */}
      <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          {subject ? 'Actualizar' : 'Guardar'}
        </button>
      </div>
    </form>
  );
};

export default SubjectForm;